import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface VisualTypeOption {
  type: string;
  label: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'app-inbuilt-visual',
  standalone: false,
  templateUrl: './inbuilt-visual.component.html',
  styleUrl: './inbuilt-visual.component.scss'
})
export class InbuiltVisualComponent {
  @Input() disabled = false;
  // Owned/toggled by the parent (gates on hasDataSource) - rendered here so the dropdown anchors under this button.
  @Input() showVisualMenu = false;
  @Input() visualTypeOptions: VisualTypeOption[] = [];
  @Output() addVisual = new EventEmitter<void>();
  @Output() visualTypeSelected = new EventEmitter<VisualTypeOption>();
}
